import { Injectable } from '@angular/core';
import { FrappeApp, FrappeAuth, FrappeCall } from 'frappe-js-sdk';
import { environment } from '../../../environments/environment';
import { AuthResponse } from 'frappe-js-sdk/lib/auth/types';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private frappe: FrappeApp;
  private frappeAuth: FrappeAuth;
  private frappeCall: FrappeCall;

  constructor() {
    this.frappe = new FrappeApp(environment.FRAPPE_API_URL);
    this.frappeAuth = this.frappe.auth();
    this.frappeCall=this.frappe.call()
  }

  public login(username: string, password: string): Promise<AuthResponse> {
    return this.frappeAuth.loginWithUsernamePassword({ username: username, password: password })
  }

  public getLoggedInUser(): Promise<string> {
    return this.frappeAuth.getLoggedInUser();
  }

  public logout(): Promise<void> {
    return this.frappeAuth.logout();
  }

  public getSearch(searchText: string): Promise<any> {
    return this.frappeCall.get('vendor_portal.api.search.perform_search_across_doctypes', {
      search_text: searchText
    });
  }

  public getVendorCode(loggedInUser: string): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_vendorCode_from_user', {
      loggedInUser: loggedInUser
    });
  }

  public getUserDetail(loggedInUser: string): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.getUserDetail', {
      loggedInUser: loggedInUser
    });
  }

  public updatePassword(newPassword: string): Promise<string> {
    return this.frappeCall.post('vendor_portal.rest.update_user_password', {
      new_password: newPassword
    });
  }
}
